import React, { Component } from 'react';
import Header from '../../Shared/Header';
import Footer from '../../Shared/Footer';
import Footer2 from '../../Shared/Footer2';
import '../../../css/CustomerSupport/AllQueries.css';
import rightarrow from '../../../Assets/ContainerStatus/Assets_Desktop/arrow-right-red.svg';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import TitleDescription from '../../../Data/Shared/TitleDescription.json';
import data from '../../../Data/CustomerSupport/AllQueries.json';

class AllQueries extends Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            StatusPending: [],
            StatusClosed: [],
        }
    }

    handleQueryDetails = event => {
        this.props.history.push('/QueryDetails')
    }

    render() {
        const StatusPending = data?.filter((dataS) => dataS.Status === 'PENDING');
        const StatusClosed = data?.filter((dataS) => dataS.Status === 'CLOSED');
        return (
            <div class="contactcaacsoutercolor">
                <MetaDecorator title={TitleDescription.allQueriesPageTitle} description={TitleDescription.allQueriesPageDescription} />
                <Header  tilesFetched = {()=>{}}/>
                <div class="contactcaacsnofullprepro">
                    <div id="contactcaacsnobox1prepro">
                        <nav class="contactcaacnononavbar">
                            <div className="contactarcaacnonavbarname">
                                <small id="contactnonavc">All Queries</small>
                            </div>
                        </nav>
                        <hr class="hr1" />
                        <div class="allQueriesmaincarddiv">
                            <div>
                                <div class="allqueriestitlediv">
                                    <small class="allqueriestitle">
                                        Active Queries ({StatusPending?.length})
                                   </small>
                                </div>
                                <div class="allqueriesdivlow">
                                    {(StatusPending?.map((queries, index) => {
                                        return (
                                            <div class="allqueriesdivlowcard" onClick={() => this.handleQueryDetails(index)}>
                                                <div class="allqueriesdivlowcardin">
                                                    <div class="allqueriesrowin1">
                                                        <div class="allqueriescol1">
                                                            <div class="allqueriescolrow1">
                                                                <small class="allqueriescolsm">Category : </small>
                                                                <small class="allqueriescolsmb">{queries?.Category}</small>
                                                            </div>
                                                            <div class="allqueriescolrow2">
                                                                <small class="allqueriescolsm">Reference No. : </small>
                                                                <small class="allqueriescolsmb">{queries?.ReferenceNo}</small>
                                                            </div>
                                                        </div>
                                                        <div class="allqueriescol2">
                                                            <div class="allqueriescolrow1">
                                                                <small class="allqueriescolsm">Initiated on: </small>
                                                                <small class="allqueriescolsmb">{queries?.Initiatedon}</small>
                                                            </div>
                                                            <div class="allqueriescolrow2b">
                                                                <small class="allqueriescolsmstatus">Status : </small>
                                                                {(queries?.Status === "PENDING") ?
                                                                    <small class="allqueriescolsmbpending">{queries?.Status}</small>
                                                                    :
                                                                    <small class="allqueriescolsmbclosed">{queries?.Status}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="allqueriesrowin2">
                                                        <img src={rightarrow} class="aalqrightimg" alt="" loading="lazy" width="17" height="17" />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }))}
                                </div>
                            </div>
                            <div>
                                <div class="allqueriestitlediv">
                                    <small class="allqueriestitle">
                                        Archived Queries ({StatusClosed?.length})
                                   </small>
                                </div>
                                <div class="allqueriesdivlow">
                                    {(StatusClosed?.map((queries, index) => {
                                        return (
                                            <div class="allqueriesdivlowcard" >
                                                <div class="allqueriesdivlowcardin">
                                                    <div class="allqueriesrowin1">
                                                        <div class="allqueriescol1">
                                                            <div class="allqueriescolrow1">
                                                                <small class="allqueriescolsm">Category : </small>
                                                                <small class="allqueriescolsmb">{queries?.Category}</small>
                                                            </div>
                                                            <div class="allqueriescolrow2">
                                                                <small class="allqueriescolsm">Reference No. : </small>
                                                                <small class="allqueriescolsmb">{queries?.ReferenceNo}</small>
                                                            </div>
                                                        </div>
                                                        <div class="allqueriescol2">
                                                            <div class="allqueriescolrow1">
                                                                <small class="allqueriescolsm">Initiated on: </small>
                                                                <small class="allqueriescolsmb">{queries?.Initiatedon}</small>
                                                            </div>
                                                            <div class="allqueriescolrow2b">
                                                                <small class="allqueriescolsmstatus">Status : </small>
                                                                {(queries?.Status === "PENDING") ?
                                                                    <small class="allqueriescolsmbpending">{queries?.Status}</small>
                                                                    :
                                                                    <small class="allqueriescolsmbclosed">{queries?.Status}</small>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="allqueriesrowin2">
                                                        <img src={rightarrow} class="aalqrightimg" alt="" loading="lazy" width="17" height="17" />
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    }))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="caanotifooter01ahzpreexp">
                    <Footer />
                </div>
                <div class="caanotifooter02ahzpreexp">
                    <Footer2 />
                </div>
            </div>
        );
    }
}

export default AllQueries;